import { httpGet, httpPatch, httpPost } from '../services/http'
import authProvider from '../utils/authProvider'

const userApi = process.env.REACT_APP_USER_API
const uranusUserApi = process.env.REACT_APP_URANUS_USER_API

const UserProvider = {
  getOne: async (resource, params) => {
    const token = await authProvider.getToken()
    const headers = { Authorization: `Bearer ${token}` }
    const { data: response } = await httpGet({ url: `${userApi}/${params.id}`, config: { headers } })
    return Promise.resolve({ data: response })
  },

  update: async (resource, { data, id }) => {
    const token = await authProvider.getToken()
    const headers = { Authorization: `Bearer ${token}` }
    const { data: response } = await httpPatch({ url: `${userApi}/${id}`, config: { headers }, data: data })
    return Promise.resolve({ data: response })
  },

  create: async (resource, params) => {
    const data = { ...params.data }
    data.status = 'active'
    data.lang = 'it'
    const token = await authProvider.getToken()
    const headers = { Authorization: `Bearer ${token}` }
    const { data: response } = await httpPost({ url: `${uranusUserApi}`, config: { headers }, data: data })
    return Promise.resolve({ data: response })
  },

  checkEmailIsUnique: async (value) => {
    const token = await authProvider.getToken()
    const headers = { Authorization: `Bearer ${token}` }
    const { data: response } = await httpGet({ url: `${userApi}/validate/email/${value}`, config: { headers } })
    return response
  },

  getList: async (resource, { filter }) => {
    const token = await authProvider.getToken()
    const headers = { Authorization: `Bearer ${token}` }
    const url = `${uranusUserApi}?f=${JSON.stringify(filter)}`
    const { data: response } = await httpGet({ url, config: { headers } })
    return Promise.resolve({ data: response.items, total: response.count })
  },
}

export default UserProvider
